import { SegmentHeader } from "@/components/campaign/basic/SegmentHeader";
import { CheckCard } from "@/components/generic/CheckCard";
import { FilterGroupComponentProps } from "@/data/filters/filter-types";
import { useReportDirty } from "@/hooks/use-report-dirty";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "react-aria-components";
import { useForm } from "react-hook-form";
import { match } from "ts-pattern";
import { z } from "zod";

const schema = z.object({
  value: z.boolean(),
});

export function CheckmarkFilter({
  group: { title, description, checkLabel, isNullCheck = false },
  formId,
  queryFilters,
  update,
  setIsDirty,
}: FilterGroupComponentProps<
  "value",
  {
    checkLabel: string;
    isNullCheck?: boolean;
  }
>) {
  const checkMarkFilter = queryFilters.value;

  const { control, handleSubmit, formState } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      value: isNullCheck
        ? match(checkMarkFilter?.operator)
            .with("NotNull", () => true)
            .otherwise(() => false)
        : match(checkMarkFilter?.values?.[0])
            .with("true", () => true)
            .otherwise(() => false),
    },
  });

  useReportDirty(formState.isDirty, setIsDirty);

  const submit = handleSubmit((data) => {
    const newCheckmarkFilter = match(data)
      .with({ value: true }, () =>
        isNullCheck
          ? {
              operator: "NotNull" as const,
              values: [],
            }
          : {
              operator: "Equal" as const,
              values: ["true"],
            },
      )
      .otherwise(() => undefined);

    update({
      value: newCheckmarkFilter,
    });
  });

  return (
    <Form
      className="flex size-full flex-col items-center justify-between gap-y-12"
      id={formId}
      onSubmit={submit}
    >
      <div className="flex flex-col items-center gap-y-9">
        <SegmentHeader title={title} description={description} />
        <CheckCard
          control={control}
          name="value"
          label={checkLabel}
          data-testid="checkmarkfilter-checkbox"
        />
      </div>
    </Form>
  );
}
